module.exports = __webpack_public_path__ + "static/media/settle_white.392f64b5.svg";